export const DISTRIBUTION_ERROR_MESSAGES = {
  402: { key: "distribution-insufficient", fallback: "Insufficient balance" },
  403: { key: "distribution-ineligible-chat", fallback: "Some selected chats are not eligible for distribution" },
  404: { key: "distribution-grid-unavailable", fallback: "This grid is no longer available" },
  422: { key: "distribution-invalid-data", fallback: "Invalid distribution data" }
} as const
